import { SearchWidgetSkeleton, SearchWidgetSkeletonFieldInterface } from './search-widget-skeleton';

export interface AssistanceSearchWidgetSkeletonProps {
	isFadingOut?: boolean;
}

const assistanceSearchFields: SearchWidgetSkeletonFieldInterface[] = [
	{ id: 'destination', flex: 1.6, minWidth: 160 },
	{ id: 'dates', flex: 1.4, minWidth: 150 },
	{ id: 'passengers', flex: 1.2, minWidth: 140 },
];

export function AssistanceSearchWidgetSkeleton({ isFadingOut }: Readonly<AssistanceSearchWidgetSkeletonProps>): JSX.Element {
	return <SearchWidgetSkeleton testIdPrefix='assistances-search.widget' fields={assistanceSearchFields} isFadingOut={isFadingOut} />;
}

export default AssistanceSearchWidgetSkeleton;
